// ToolGood.Words.Translate.js
// 2020, Lin Zhijun, https://github.com/toolgood/ToolGood.Words
// Licensed under the Apache License 2.0
/* eslint-disable */
module.exports.Translate = function Translate() {
    function WordsSearch() {
        function TrieNode() {
            this.Index = 0;
            this.Layer = 0;
            this.End = false;
            this.Char = '';
            this.Results = [];
            this.m_values = {};
            this.Failure = null;
            this.Parent = null;

            this.Add = function (c) {
                if (this.m_values[c] != null) {
                    return this.m_values[c];
                }
                var node = new TrieNode();
                node.Parent = this;
                node.Char = c;
                this.m_values[c] = node;
                return node;
            }

            this.SetResults = function (index) {
                if (this.End == false) {
                    this.End = true;
                }
                this.Results.push(index)
            }
        }

        function TrieNode2() {
            this.End = false;
            this.Results = [];
            this.m_values = {};
            this.minflag = 1;
            this.maxflag = 0;

            this.Add = function (c, node3) {
                if (typeof c !== 'number') {
                    c = parseInt(c);
                }
                if (this.minflag > c) {
                    this.minflag = c;
                }
                if (this.maxflag < c) {
                    this.maxflag = c;
                }
                this.m_values[c] = node3;
            }
            this.SetResults = function (index) {
                if (this.End == false) {
                    this.End = true;
                }
                if (this.Results.indexOf(index) == -1) {
                    this.Results.push(index);
                }
            }
            this.HasKey = function (c) {
                return this.m_values[c] != undefined;
            }
            this.TryGetValue = function (c) {
                if (this.minflag <= c && this.maxflag >= c) {
                    return this.m_values[c];
                }
                return null;
            }
        }

        var _first = [];
        var _keywords = [];
        this._others = [];

        this.SetKeywords = function (keywords) {
            _keywords = keywords;
            var root = new TrieNode();

            var allNodeLayer = {};
            for (var i = 0; i < _keywords.length; i++) {
                var p = _keywords[i];
                var nd = root;
                for (var j = 0; j < p.length; j++) {
                    nd = nd.Add(p.charCodeAt(j));
                    if (nd.Layer == 0) {
                        nd.Layer = j + 1;
                        if (allNodeLayer[nd.Layer]) {
                            allNodeLayer[nd.Layer].push(nd)
                        } else {
                            allNodeLayer[nd.Layer] = [];
                            allNodeLayer[nd.Layer].push(nd)
                        }
                    }
                }
                nd.SetResults(i);
            }

            var allNode = [];
            allNode.push(root);
            for (var key in allNodeLayer) {
                var nds = allNodeLayer[key];
                for (var i = 0; i < nds.length; i++) {
                    allNode.push(nds[i]);
                }
            }
            allNodeLayer = null;

            for (var i = 1; i < allNode.length; i++) {
                var nd = allNode[i];
                nd.Index = i;
                var r = nd.Parent.Failure;
                var c = nd.Char;
                while (r != null && !r.m_values[c])
                    r = r.Failure;
                if (r == null)
                    nd.Failure = root;
                else {
                    nd.Failure = r.m_values[c];
                    for (var key2 in nd.Failure.Results) {
                        if (nd.Failure.Results.hasOwnProperty(key2) == false) {
                            continue;
                        }
                        var result = nd.Failure.Results[key2];
                        nd.SetResults(result);
                    }
                }
            }
            root.Failure = root;

            var allNode2 = [];
            for (var i = 0; i < allNode.length; i++) {
                allNode2.push(new TrieNode2());
            }
            for (var i = 0; i < allNode2.length; i++) {
                var oldNode = allNode[i];
                var newNode = allNode2[i];

                for (var key in oldNode.m_values) {
                    if (oldNode.m_values.hasOwnProperty(key) == false) {
                        continue;
                    }
                    var index = oldNode.m_values[key].Index;
                    newNode.Add(key, allNode2[index]);
                }
                for (let index = 0; index < oldNode.Results.length; index++) {
                    var item = oldNode.Results[index];
                    newNode.SetResults(item);
                }

                oldNode = oldNode.Failure;
                while (oldNode != root) {
                    for (var key in oldNode.m_values) {
                        if (oldNode.m_values.hasOwnProperty(key) == false) {
                            continue;
                        }
                        if (newNode.HasKey(key) == false) {
                            var index = oldNode.m_values[key].Index;
                            newNode.Add(key, allNode2[index]);
                        }
                    }
                    for (let index = 0; index < oldNode.Results.length; index++) {
                        var item = oldNode.Results[index];
                        newNode.SetResults(item);
                    }
                    oldNode = oldNode.Failure;
                }
            }
            allNode = null;
            root = null;

            //var first = [];
            //for (let index = 0; index < 0xffff; index++) {
            //    first.push(null);
            //}
            //for (var key in allNode2[0].m_values) {
            //    if (allNode2[0].m_values.hasOwnProperty(key) == false) { continue; }
            //    first[key] = allNode2[0].m_values[key];
            //}
            _first = allNode2[0];
        }

        this.FindAll = function (text) {
            var ptr = null;
            var list = [];

            for (let i = 0; i < text.length; i++) {
                var t = text.charCodeAt(i);
                var tn = null;
                if (ptr == null) {
                    tn = _first.TryGetValue(t);
                } else {
                    tn = ptr.TryGetValue(t);
                    if (!tn) {
                        tn = _first.TryGetValue(t);
                    }
                }
                if (tn != null) {
                    if (tn.End) {
                        for (let j = 0; j < tn.Results.length; j++) {
                            var item = tn.Results[j];
                            var keyword = _keywords[item];
                            list.push({
                                Keyword: keyword,
                                Success: true,
                                End: i,
                                Start: i + 1 - _keywords[item].length,
                                Index: item,
                            });
                        }
                    }
                }
                ptr = tn;
            }
            return list;
        }
    }

    //---------------------------
    const {
        _s2t_s,
        _s2t_t,
        _t2hk_hk,
        _t2hk_t,
        _t2s_s,
        _t2s_t,
        _t2tw_t,
        _t2tw_tw,
    } = require("./data.json");

    //-----------------------
    var s2tSearch = null; // WordsSearch
    var t2sSearch = null;// WordsSearch
    var t2twSearch = null;// WordsSearch
    var tw2tSearch = null;// WordsSearch
    var t2hkSearch = null;// WordsSearch
    var hk2tSearch = null;// WordsSearch

    /**
     * 转繁体中文
     * @param {any} text 原文本
     * @param {any} type 0、繁体中文，1、港澳繁体，2、台湾正体
     */
    this.ToTraditionalChinese = function (text, type) {
        console.log(11);
        if (type == undefined) {
            type = 0;
        }
        if (type > 2 || type < 0) {
            throw "type 不支持该类型";
        }

        var s2t = GetWordsSearch(true, 0);
        text = TransformationReplace(text, s2t);
        if (type > 0) {
            var t2 = GetWordsSearch(true, type);
            text = TransformationReplace(text, t2);
        }
        return text;
    }

    /**
     * 转简体中文
     * @param {any} text 原文本
     * @param {any} srcType 0、繁体中文，1、港澳繁体，2、台湾正体
     */
    this.ToSimplifiedChinese = function (text, srcType) {
        if (srcType == undefined) {
            srcType = 0;
        }
        if (srcType > 2 || srcType < 0) {
            throw "srcType 不支持该类型";
        }
        if (srcType > 0) {
            var t2 = GetWordsSearch(false, srcType);
            text = TransformationReplace(text, t2);
        }
        var s2t = GetWordsSearch(false, 0);
        text = TransformationReplace(text, s2t);
        return text;
    }

    function TransformationReplace(text, wordsSearch) {
        var ts = wordsSearch.FindAll(text);

        var sb = "";
        var index = 0;
        while (index < text.length) {
            var t = null;
            var max = -1;
            for (var i = 0; i < ts.length; i++) {
                var f = ts[i];
                if (f.Start == index && f.End > max) {
                    max = f.End;
                    t = f;
                }
            }

            if (t == null) {
                sb += text[index];
                index++;
            } else {
                sb += wordsSearch._others[t.Index]
                index = t.End + 1;
            }
        }
        return sb;
    }

    function GetWordsSearch(s2t, srcType) {
        if (s2t) {
            if (srcType == 0) {
                if (s2tSearch == null) {
                    s2tSearch = BuildWordsSearch(_s2t_s, _s2t_t);
                }
                return s2tSearch;
            } else if (srcType == 1) {
                if (t2hkSearch == null) {
                    t2hkSearch = BuildWordsSearch(_t2hk_t, _t2hk_hk);
                }
                return t2hkSearch;
            } else if (srcType == 2) {
                if (t2twSearch == null) {
                    t2twSearch = BuildWordsSearch(_t2tw_t, _t2tw_tw);
                }
                return t2twSearch;
            }
        }
        if (srcType == 0) {
            if (t2sSearch == null) {
                t2sSearch = BuildWordsSearch(_t2s_t, _t2s_s);
            }
            return t2sSearch;
        } else if (srcType == 1) {
            if (hk2tSearch == null) {
                hk2tSearch = BuildWordsSearch(_t2hk_hk, _t2hk_t);
            }
            return hk2tSearch;
        } else if (srcType == 2) {
            if (tw2tSearch == null) {
                tw2tSearch = BuildWordsSearch(_t2tw_tw, _t2tw_t);
            }
            return tw2tSearch;
        }
        return null;
    }

    function BuildWordsSearch(keywords, toWords) {
        var wordsSearch = new WordsSearch();
        wordsSearch.SetKeywords(keywords);
        wordsSearch._others = toWords;
        return wordsSearch;
    }
}
